import { Center } from '@chakra-ui/react';
import { SpinnerLoader } from '@kula-ai/components';

/** Holds a lazy editor field's space while its chunk loads. */
export const EditorPlaceholder = ({ minH }: { minH: string }) => (
  <Center minH={minH} data-test-id="lazy-editor-loading">
    <SpinnerLoader size="sm" />
  </Center>
);
